/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ base: NonNullable<unknown> }} Partner_Admin_Commission_Base_MismatchInputs */



/**
* | output |
* | --- |
* | "Accrued on {base}, not the total above" |
*
* @param {Partner_Admin_Commission_Base_MismatchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_base_mismatch = /** @type {((inputs: Partner_Admin_Commission_Base_MismatchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Base_MismatchInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abgerechnet auf ${i?.base}, nicht auf die Summe oben`)
	return /** @type {LocalizedString} */ (`Accrued on ${i?.base}, not the total above`)
});